import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { select, Store } from '@ngrx/store';
import { IAppState } from '../../store/app.state';
import { Actions, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { DownloadService } from 'src/app/services/download.service';
import { Table } from 'primeng/table';
import { selectProgramasList } from 'src/app/store/selectors/programas.selectors';
import {
  DeleteProgramaSuccess, GetProgramas, UpdateProgramaSuccess, CreateProgramaSuccess,
  DeletePrograma, CreatePrograma, UpdatePrograma, GetProgramasSuccess
} from 'src/app/store/actions/programas.actions';
import { ICreatePrograma, IPrograma, IUpdatePrograma } from 'src/app/interfaces/programas.insterface';
import { selectInstitucionesList } from 'src/app/store/selectors/instituciones.selectors';
import { GetInstituciones } from 'src/app/store/actions/instituciones.actions';
import { AuthenticationService } from '../../services/authentication.service';
import { selectFormulariosList } from 'src/app/store/selectors/formularios.selectors';
import { CreateFormularioPrograma, CreateFormularioprogramaSuccess, GetFormularios } from 'src/app/store/actions/formularios.actions';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { combineLatest } from 'rxjs';
import { selectBeneficiariosList } from 'src/app/store/selectors/beneficiarios.selectors';
import { GetBeneficiarios } from 'src/app/store/actions/beneficiarios.actions';


@Component({
  selector: 'app-programas',
  templateUrl: './programas.component.html',
  styleUrls: ['./programas.component.scss']
})
export class ProgramasComponent implements OnInit, OnDestroy {
  @ViewChild('dt', { static: false }) table: Table;

  combined = combineLatest([
    this.store$.select(selectProgramasList),
    this.store$.select(selectBeneficiariosList)
  ]);

  programas = this.combined.pipe(
    map(([programas, beneficiarios]) => {
      return programas.map(programa => {
        this.programasExcel.push(programa);

        const num = beneficiarios.filter(beneficiario => beneficiario.programa === programa.programa_social);

        return {
          ...programa,
          institucion: programa.institucion === '' ? 'N/A' : programa.institucion,
          num_beneficiarios: num.length
        }
      })
    })
  );

  beneficiarios = this.store$.pipe(
    select(selectBeneficiariosList),
    map(beneficiarios => beneficiarios.map(beneficiario => {
      return {
        ...beneficiario
      }
    }))
  );

  getSubscription = this.actions$.pipe(
    ofType(GetProgramasSuccess),
  ).subscribe(_ => {
    // this.currentToken = this.authenticationService.currentTokenValue;
  });

  instituciones = this.store$.pipe(
    select(selectInstitucionesList),
    map(instituciones => instituciones.map(insitucion => {
      return { label: insitucion.institucion, value: insitucion.institucion }
    }))
  );

  formularios = this.store$.pipe(
    select(selectFormulariosList),
    map(formularios => formularios.map(formulario => {
      return { label: formulario.titulo, value: formulario.form }
    }))
  );

  createFormulariosSubscription = this.actions$.pipe(
    ofType(CreateFormularioprogramaSuccess),
  ).subscribe(_ => {
    this.spinner = false;
  });

  cols: any[];
  exportColumns: any[];
  currentToken = '';
  mode = '';
  header = '';
  displayForm = false;
  formPrograma: FormGroup;
  displayFormulario = false;
  formularioAsignado: any;
  formularioAsignadoData: any;
  spinner = false;
  programasExcel = [];
  dataForExcel = [];

  tipoInstitucion = [
    { label: 'Pública', value: 'publica' },
    { label: 'Privada', value: 'privada' }
  ];

  downloadItems = [
    { label: 'CSV', command: () => { this.downloadService.exportCSV('programas', this.table) } },
    { label: 'PDF', command: () => { this.downloadService.exportPdf('programas', this.table) } },
  ];

  formSubmitSubscription = this.actions$.pipe(
    ofType(UpdateProgramaSuccess, DeleteProgramaSuccess, CreateProgramaSuccess),
    tap(_ => {
      this.store$.dispatch(GetProgramas());
      this.displayForm = false;
    })
  ).subscribe();

  constructor(
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    private store$: Store<IAppState>,
    private actions$: Actions,
    public downloadService: DownloadService,
    private authenticationService: AuthenticationService,
    private ete: ExportExcelService
  ) {
    this.currentToken = this.authenticationService.currentTokenValue;

    this.formPrograma = this.formBuilder.group({
      _id: new FormControl(''),
      programa_social: new FormControl(''),
      institucion: new FormControl(''),
      tipo_institucion: new FormControl(''),
      problema: new FormControl(''),
      descripcion: new FormControl(''),
      tipo_apoyo: new FormControl(''),
      concepto_apoyo: new FormControl(''),
      monto: new FormControl(''),
      poblacion_objetivo: new FormControl(''),
      // numero_beneficiarios: new FormControl(''),
      estado: new FormControl(''),
      municipio: new FormControl('')
    });
  }

  ngOnInit() {
    this.cols = [
      { field: 'programa_social', header: 'Programa Social', exportable: true },
      { field: 'institucion', header: 'Institución', exportable: true },
      { field: 'num_beneficiarios', header: 'Número de beneficiarios', exportable: true },
      { field: 'problema', header: 'Problemática', exportable: true },
      { field: 'tipo_apoyo', header: 'Tipo de apoyo', exportable: true },
      { field: 'acciones', header: 'Acciones', exportable: false }
    ];

    this.store$.dispatch(GetBeneficiarios());
    this.store$.dispatch(GetProgramas());
    this.store$.dispatch(GetInstituciones());
    this.store$.dispatch(GetFormularios());
  }

  ngOnDestroy() {
    this.formSubmitSubscription.unsubscribe();
  }

  editarPrograma(programa): void {
    this.mode = 'EDITAR'
    this.header = 'Editar Programa Social';
    this.formPrograma.patchValue({
      ...programa
    });
    this.formPrograma.enable();

    this.displayForm = true;
  }

  verPrograma(programa): void {
    this.mode = 'DETALLE'
    this.header = 'Detalle Programa Social'
    this.formPrograma.patchValue({
      ...programa
    });
    this.formPrograma.disable();

    this.displayForm = true;
  }

  agregarPrograma() {
    this.mode = 'AGREGAR'
    this.header = 'Agregar Programa Social'
    this.formPrograma.patchValue({
      _id: '',
      programa_social: '',
      institucion: '',
      tipo_institucion: '',
      problema: '',
      descripcion: '',
      tipo_apoyo: '',
      concepto_apoyo: '',
      monto: '',
      poblacion_objetivo: '',
      // numero_beneficiarios: '',
      estado: '',
      municipio: ''
    })
    this.formPrograma.enable();

    this.displayForm = true;
  }

  borrarPrograma(programa: IPrograma) {
    this.confirmationService.confirm({
      header: 'Borrar Programa Social',
      message: `¿Seguro que quiere borrar el programa social '${programa.programa_social}'?`,
      acceptLabel: 'Aceptar',
      rejectVisible: false,
      accept: async () => {
        this.store$.dispatch(DeletePrograma({ id: programa._id }))
      }
    });
  }

  submitForm() {
    const form: IPrograma = this.formPrograma.getRawValue();

    if (this.mode === 'AGREGAR') {
      const payload: ICreatePrograma = {
        ...form,
      }

      this.store$.dispatch(CreatePrograma({ programa: payload }));
    } else if (this.mode === 'EDITAR') {
      const payload: IUpdatePrograma = {
        ...form,
      }

      this.store$.dispatch(UpdatePrograma({ id: form._id, programa: payload }));
    }

    return;
  }

  verFormularios(programa: IPrograma) {
    this.header = 'Formularios';
    this.displayFormulario = true;
    this.formularioAsignadoData = { form: '', programa: programa.programa_social || [] };
  }

  asignarFormulario() {
    this.spinner = true;
    this.formularioAsignadoData.form = this.formularioAsignado;
    this.store$.dispatch(CreateFormularioPrograma({ formulariosAsignados: this.formularioAsignadoData }));
  }

  exportToExcel() {
    this.dataForExcel = [];

    const uniqueArray = this.programasExcel.filter((value, index) => {
      const _value = JSON.stringify(value);
      return index === this.programasExcel.findIndex(obj => {
        return JSON.stringify(obj) === _value;
      });
    });

    uniqueArray.forEach((row: any) => {
      const insert = { ...row }
      this.dataForExcel.push(Object.values(insert))
    })

    const headers = {
      id: '',
      'Programa Social': '',
      Institucion: '',
      'Tipo de Institución': '',
      Problema: '',
      Descripcion: '',
      'Tipo de Apoyo': '',
      'Concepto de Apoyo': '',
      'Monto de Apoyo': '',
      'Poblacion Objetivo': '',
      'Numero de Beneficiarios': '',
      Estado: '',
      Municipio: ''
    }

    const reportData = {
      title: 'Programas Sociales',
      data: this.dataForExcel,
      headers: Object.keys(headers)
    }

    this.ete.exportExcel(reportData, false);
  }
}
